import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  isLoading: BehaviorSubject<LoaderConfig> = new BehaviorSubject<LoaderConfig>({
    _isLoading: false,
    loaderType: 'NONE'
  });

  //method to show the spinner, by default the type of the spinner would be NONE
  show(loaderConfig?:LoaderConfig): void {
    this.isLoading.next({
      _isLoading: true,
      loaderType: loaderConfig?.loaderType || 'NONE',
      appearAsModal: loaderConfig?.appearAsModal,
      loaderText: loaderConfig?.loaderText
    });
  }

  //method to hide the spinner
  hide(): void {
    this.isLoading.next({
      _isLoading: false,
      loaderType: 'NONE'
    });
  }
}

//type of loaders available
export type LoaderType = 'NONE' | 'SPINNER';

//loader config
export interface LoaderConfig {
  _isLoading?: boolean;
  loaderType: LoaderType;
  /**
   * loaderText is a optional field, it refers to the text that shpuld appear below the loader. 
   * If no text needs to be displayed, then loaderText need not be defined
   */
  loaderText?: string;
  /**
   * appearAsModal is a boolean property, if set to true the loader would appear as a modal. 
   * it is a optional property, if the loader need not appear as modal then this propery should not be defined.
   */
  appearAsModal?: boolean;
}
